import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import logo from "../assets/logo.png";
import footerLogo from "../assets/footer-logo.png";
import { collection, addDoc, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";

// Complete list of countries with their phone codes
const countries = [
  { name: "Afghanistan", code: "+93" },
  { name: "Albania", code: "+355" },
  { name: "Algeria", code: "+213" },
  { name: "Andorra", code: "+376" },
  { name: "Angola", code: "+244" },
  { name: "Argentina", code: "+54" },
  { name: "Armenia", code: "+374" },
  { name: "Australia", code: "+61" },
  { name: "Austria", code: "+43" },
  { name: "Azerbaijan", code: "+994" },
  { name: "Bahamas", code: "+1-242" },
  { name: "Bahrain", code: "+973" },
  { name: "Bangladesh", code: "+880" },
  { name: "Barbados", code: "+1-246" },
  { name: "Belarus", code: "+375" },
  { name: "Belgium", code: "+32" },
  { name: "Belize", code: "+501" },
  { name: "Benin", code: "+229" },
  { name: "Bhutan", code: "+975" },
  { name: "Bolivia", code: "+591" },
  { name: "Bosnia and Herzegovina", code: "+387" },
  { name: "Botswana", code: "+267" },
  { name: "Brazil", code: "+55" },
  { name: "Brunei", code: "+673" },
  { name: "Bulgaria", code: "+359" },
  { name: "Burkina Faso", code: "+226" },
  { name: "Burundi", code: "+257" },
  { name: "Cambodia", code: "+855" },
  { name: "Cameroon", code: "+237" },
  { name: "Canada", code: "+1" },
  { name: "Cape Verde", code: "+238" },
  { name: "Central African Republic", code: "+236" },
  { name: "Chad", code: "+235" },
  { name: "Chile", code: "+56" },
  { name: "China", code: "+86" },
  { name: "Colombia", code: "+57" },
  { name: "Comoros", code: "+269" },
  { name: "Congo", code: "+242" },
  { name: "Costa Rica", code: "+506" },
  { name: "Croatia", code: "+385" },
  { name: "Cuba", code: "+53" },
  { name: "Cyprus", code: "+357" },
  { name: "Czech Republic", code: "+420" },
  { name: "Denmark", code: "+45" },
  { name: "Djibouti", code: "+253" },
  { name: "Dominica", code: "+1-767" },
  { name: "Dominican Republic", code: "+1-809" },
  { name: "Ecuador", code: "+593" },
  { name: "Egypt", code: "+20" },
  { name: "El Salvador", code: "+503" },
  { name: "Equatorial Guinea", code: "+240" },
  { name: "Eritrea", code: "+291" },
  { name: "Estonia", code: "+372" },
  { name: "Ethiopia", code: "+251" },
  { name: "Fiji", code: "+679" },
  { name: "Finland", code: "+358" },
  { name: "France", code: "+33" },
  { name: "Gabon", code: "+241" },
  { name: "Gambia", code: "+220" },
  { name: "Georgia", code: "+995" },
  { name: "Germany", code: "+49" },
  { name: "Ghana", code: "+233" },
  { name: "Greece", code: "+30" },
  { name: "Grenada", code: "+1-473" },
  { name: "Guatemala", code: "+502" },
  { name: "Guinea", code: "+224" },
  { name: "Guinea-Bissau", code: "+245" },
  { name: "Guyana", code: "+592" },
  { name: "Haiti", code: "+509" },
  { name: "Honduras", code: "+504" },
  { name: "Hungary", code: "+36" },
  { name: "Iceland", code: "+354" },
  { name: "India", code: "+91" },
  { name: "Indonesia", code: "+62" },
  { name: "Iran", code: "+98" },
  { name: "Iraq", code: "+964" },
  { name: "Ireland", code: "+353" },
  { name: "Israel", code: "+972" },
  { name: "Italy", code: "+39" },
  { name: "Jamaica", code: "+1-876" },
  { name: "Japan", code: "+81" },
  { name: "Jordan", code: "+962" },
  { name: "Kazakhstan", code: "+7" },
  { name: "Kenya", code: "+254" },
  { name: "Kiribati", code: "+686" },
  { name: "Kuwait", code: "+965" },
  { name: "Kyrgyzstan", code: "+996" },
  { name: "Laos", code: "+856" },
  { name: "Latvia", code: "+371" },
  { name: "Lebanon", code: "+961" },
  { name: "Lesotho", code: "+266" },
  { name: "Liberia", code: "+231" },
  { name: "Libya", code: "+218" },
  { name: "Liechtenstein", code: "+423" },
  { name: "Lithuania", code: "+370" },
  { name: "Luxembourg", code: "+352" },
  { name: "Madagascar", code: "+261" },
  { name: "Malawi", code: "+265" },
  { name: "Malaysia", code: "+60" },
  { name: "Maldives", code: "+960" },
  { name: "Mali", code: "+223" },
  { name: "Malta", code: "+356" },
  { name: "Marshall Islands", code: "+692" },
  { name: "Mauritania", code: "+222" },
  { name: "Mauritius", code: "+230" },
  { name: "Mexico", code: "+52" },
  { name: "Micronesia", code: "+691" },
  { name: "Moldova", code: "+373" },
  { name: "Monaco", code: "+377" },
  { name: "Mongolia", code: "+976" },
  { name: "Montenegro", code: "+382" },
  { name: "Morocco", code: "+212" },
  { name: "Mozambique", code: "+258" },
  { name: "Myanmar", code: "+95" },
  { name: "Namibia", code: "+264" },
  { name: "Nauru", code: "+674" },
  { name: "Nepal", code: "+977" },
  { name: "Netherlands", code: "+31" },
  { name: "New Zealand", code: "+64" },
  { name: "Nicaragua", code: "+505" },
  { name: "Niger", code: "+227" },
  { name: "Nigeria", code: "+234" },
  { name: "North Korea", code: "+850" },
  { name: "North Macedonia", code: "+389" },
  { name: "Norway", code: "+47" },
  { name: "Oman", code: "+968" },
  { name: "Pakistan", code: "+92" },
  { name: "Palau", code: "+680" },
  { name: "Palestine", code: "+970" },
  { name: "Panama", code: "+507" },
  { name: "Papua New Guinea", code: "+675" },
  { name: "Paraguay", code: "+595" },
  { name: "Peru", code: "+51" },
  { name: "Philippines", code: "+63" },
  { name: "Poland", code: "+48" },
  { name: "Portugal", code: "+351" },
  { name: "Qatar", code: "+974" },
  { name: "Romania", code: "+40" },
  { name: "Russia", code: "+7" },
  { name: "Rwanda", code: "+250" },
  { name: "Saint Kitts and Nevis", code: "+1-869" },
  { name: "Saint Lucia", code: "+1-758" },
  { name: "Saint Vincent and the Grenadines", code: "+1-784" },
  { name: "Samoa", code: "+685" },
  { name: "San Marino", code: "+378" },
  { name: "Sao Tome and Principe", code: "+239" },
  { name: "Saudi Arabia", code: "+966" },
  { name: "Senegal", code: "+221" },
  { name: "Serbia", code: "+381" },
  { name: "Seychelles", code: "+248" },
  { name: "Sierra Leone", code: "+232" },
  { name: "Singapore", code: "+65" },
  { name: "Slovakia", code: "+421" },
  { name: "Slovenia", code: "+386" },
  { name: "Solomon Islands", code: "+677" },
  { name: "Somalia", code: "+252" },
  { name: "South Africa", code: "+27" },
  { name: "South Korea", code: "+82" },
  { name: "South Sudan", code: "+211" },
  { name: "Spain", code: "+34" },
  { name: "Sri Lanka", code: "+94" },
  { name: "Sudan", code: "+249" },
  { name: "Suriname", code: "+597" },
  { name: "Sweden", code: "+46" },
  { name: "Switzerland", code: "+41" },
  { name: "Syria", code: "+963" },
  { name: "Taiwan", code: "+886" },
  { name: "Tajikistan", code: "+992" },
  { name: "Tanzania", code: "+255" },
  { name: "Thailand", code: "+66" },
  { name: "Timor-Leste", code: "+670" },
  { name: "Togo", code: "+228" },
  { name: "Tonga", code: "+676" },
  { name: "Trinidad and Tobago", code: "+1-868" },
  { name: "Tunisia", code: "+216" },
  { name: "Turkey", code: "+90" },
  { name: "Turkmenistan", code: "+993" },
  { name: "Tuvalu", code: "+688" },
  { name: "Uganda", code: "+256" },
  { name: "Ukraine", code: "+380" },
  { name: "United Arab Emirates", code: "+971" },
  { name: "United Kingdom", code: "+44" },
  { name: "United States", code: "+1" },
  { name: "Uruguay", code: "+598" },
  { name: "Uzbekistan", code: "+998" },
  { name: "Vanuatu", code: "+678" },
  { name: "Vatican City", code: "+379" },
  { name: "Venezuela", code: "+58" },
  { name: "Vietnam", code: "+84" },
  { name: "Yemen", code: "+967" },
  { name: "Zambia", code: "+260" },
  { name: "Zimbabwe", code: "+263" },
];

export default function RegistrationForm() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    country: "",
    city: "",
    phoneCode: "",
    phoneNumber: "",
    gender: "",
    modeOfParticipation: "online",
    isMinister: "",
    expectations: "",
    paymentCurrency: "NGN (₦)",
    paymentPlan: "Full (₦225,000)",
  });

  const [showEmailExistsModal, setShowEmailExistsModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [phoneError, setPhoneError] = useState("");

  // Paystack public key
  const PAYSTACK_PUBLIC_KEY = process.env.REACT_APP_PAYSTACK_PUBLIC_KEY;

  // ================================
  // PAYMENT CONSTANTS (SINGLE SOURCE OF TRUTH)
  // ================================
  const PAYMENT_AMOUNTS = {
    full: 22500000, // ₦225,000 in kobo
    installment: 11250000, // ₦112,500 in kobo
  };

  // Calculate payment amount - Returns amount in KOBO (smallest unit)
  const getPaymentAmount = () => {
    switch (formData.paymentPlan) {
      case "Full (₦225,000)":
        return PAYMENT_AMOUNTS.full;
      case "Installment":
        return PAYMENT_AMOUNTS.installment;
      default:
        console.warn("Unknown payment plan, defaulting to full");
        return PAYMENT_AMOUNTS.full;
    }
  };

  const saveRegistrationWithPayment = async (paymentReference) => {
    try {
      // Prevent duplicate payment saves
      const q = query(
        collection(db, "registrations"),
        where("paymentReference", "==", paymentReference),
      );

      const existing = await getDocs(q);
      if (!existing.empty) {
        console.log("Payment already recorded");
        return;
      }

      await addDoc(collection(db, "registrations"), {
        ...formData,
        paymentReference,
        paymentStatus: "completed",
        createdAt: new Date().toISOString(),
      });

      console.log("Registration saved successfully");
    } catch (error) {
      console.error("Error saving registration:", error);
      alert(
        "Payment successful but registration failed. Reference: " +
          paymentReference,
      );
    }
  };

  // Defensive Paystack handler
  const handlePayment = () => {
    if (
      !window ||
      !window.PaystackPop ||
      typeof window.PaystackPop.setup !== "function"
    ) {
      alert(
        "Payment system not loaded. Please ensure you have internet access and refresh.",
      );
      console.error("Paystack not available:", window.PaystackPop);
      return;
    }

    if (!PAYSTACK_PUBLIC_KEY || typeof PAYSTACK_PUBLIC_KEY !== "string") {
      console.error("Invalid PAYSTACK_PUBLIC_KEY:", PAYSTACK_PUBLIC_KEY);
      alert("Payment key not configured. Contact support.");
      return;
    }

    if (!formData || typeof formData.email !== "string" || !formData.email) {
      console.error("Invalid formData.email:", formData);
      alert("Please provide a valid email address.");
      return;
    }

    // Ensure getPaymentAmount returns a number
    const rawAmount = getPaymentAmount();

    if (typeof rawAmount !== "number" || Number.isNaN(rawAmount)) {
      console.error("Invalid payment amount:", rawAmount);
      alert("Invalid payment amount. Check console.");
      return;
    }

    // Amount is already in kobo
    const amountInKobo = rawAmount;

    const metadata = {
      custom_fields: [
        {
          display_name: "Full Name",
          variable_name: "full_name",
          value:
            `${formData.firstName || ""} ${formData.lastName || ""}`.trim(),
        },
        {
          display_name: "Phone Number",
          variable_name: "phone_number",
          value: `${formData.phoneCode || ""}${formData.phoneNumber || ""}`,
        },
        {
          display_name: "Payment Plan",
          variable_name: "payment_plan",
          value: formData.paymentPlan || "",
        },
      ],
    };

    const handler = window.PaystackPop.setup({
      key: PAYSTACK_PUBLIC_KEY,
      email: formData.email,
      amount: amountInKobo,
      currency: "NGN",
      ref: `FLO-${Date.now()}`,
      metadata,
      callback: function (response) {
        (async () => {
          try {
            console.log("Payment successful:", response);
            if (typeof saveRegistrationWithPayment === "function") {
              await saveRegistrationWithPayment(response.reference);
            }
            setShowSuccessModal(true);
          } catch (err) {
            console.error("Error saving registration:", err);
          }
        })();
      },
      onClose: function () {
        console.log("Payment window closed");
      },
    });

    handler.openIframe();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear phone error when user types
    if (name === "phoneNumber") {
      setPhoneError("");
    }
  };

  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;
    const country = countries.find((c) => c.name === selectedCountry);

    setFormData((prev) => ({
      ...prev,
      country: selectedCountry,
      phoneCode: country ? country.code : "",
    }));
  };

  const validatePhoneNumber = () => {
    const phoneNumber = formData.phoneNumber.trim();
    if (phoneNumber.length < 7) {
      setPhoneError("Phone number must have at least 7 digits");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validatePhoneNumber()) {
      return;
    }

    if (!formData.email || !formData.firstName || !formData.lastName) {
      alert("Please fill all required fields");
      return;
    }

    // Check email exists in parallel while showing loading
    checkEmailAndPay();
  };

  const checkEmailAndPay = async () => {
    try {
      // Quick check if email exists
      const q = query(
        collection(db, "registrations"),
        where("email", "==", formData.email),
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        setShowEmailExistsModal(true);
        return;
      }

      // Open payment immediately after check
      handlePayment();
    } catch (error) {
      console.error("Error checking email:", error);
      // Even if check fails, allow payment (Fail open logic)
      handlePayment();
    }
  };

  const handleResendPaymentLink = () => {
    // Logic to resend payment link
    console.log("Resending payment link for:", formData.email);
    alert("Payment link has been resent to your email!");
    setShowEmailExistsModal(false);
  };

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);

    // Reset form
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      country: "",
      city: "",
      phoneCode: "",
      phoneNumber: "",
      gender: "",
      modeOfParticipation: "online",
      isMinister: "",
      expectations: "",
      paymentCurrency: "NGN (₦)",
      paymentPlan: "Full (₦225,000)",
    });

    // Redirect to home
    window.location.href = "/";
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* --- SEO METADATA (HELMET) --- */}
      <Helmet>
        {/* Basic Title and Description */}
        <title>Register | Femi Lanre-Oke Mentorship Academy</title>
        <meta
          name="description"
          content="Register now for the 3-Month Mentorship Academy with Dr. Femi Lanre-Oke. Unlock your potential and become a dynamic changemaker impacting societies and industries."
        />
        <meta
          name="keywords"
          content="Mentorship, Femi Lanre-Oke, Leadership, Ministry, Career Growth, Abuja, Nigeria"
        />
        <link
          rel="canonical"
          href="https://mentorship.femilanreoke.org/register"
        />

        {/* Facebook / WhatsApp (Open Graph) */}
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://mentorship.femilanreoke.org/register"
        />
        <meta property="og:title" content="Register | FLO Mentorship Academy" />
        <meta
          property="og:description"
          content="Join the 3-Month Mentorship Academy. Empowering individuals to influence societies and industries."
        />
        {/* IMPORTANT: Upload an image named 'social-preview.jpg' to your 'public' folder for this to work */}
        <meta
          property="og:image"
          content="https://mentorship.femilanreoke.org/social-preview.jpg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Register | FLO Mentorship Academy"
        />
        <meta
          name="twitter:description"
          content="Join the 3-Month Mentorship Academy. Empowering individuals to influence societies and industries."
        />
        <meta
          name="twitter:image"
          content="https://mentorship.femilanreoke.org/social-preview.jpg"
        />
      </Helmet>
      {/* ----------------------------- */}

      {/* Navigation */}
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center gap-3">
              <div className="w-32 h-12 rounded-lg overflow-hidden flex items-center justify-center">
                <img
                  src={logo}
                  alt="FLO Mentorship Logo"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>

            <div className="hidden md:flex space-x-8">
              <a
                href="/"
                className="text-gray-700 hover:text-red-600 transition"
              >
                Home
              </a>
              <a
                href="/#about"
                className="text-gray-700 hover:text-red-600 transition"
              >
                About
              </a>
              <a
                href="/#curriculum"
                className="text-gray-700 hover:text-red-600 transition"
              >
                Curriculum
              </a>
              <a
                href="/#transformation"
                className="text-gray-700 hover:text-red-600 transition"
              >
                Transformation
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Registration Form */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
            3 MONTHS MENTORSHIP ACADEMY
          </h1>
          <h2 className="text-2xl md:text-3xl font-bold text-red-600 mb-8">
            REGISTRATION FORM
          </h2>

          <div className="bg-red-50 border-l-4 border-red-600 p-4 mb-8 max-w-3xl mx-auto">
            <p className="text-red-700 text-sm md:text-base">
              <span className="font-semibold">Kindly Note:</span> Class
              commences on Thursday, 8th April 2026, and will end on the 2nd
              July 2026.
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* First Name and Last Name */}
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="block text-gray-900 font-medium mb-2">
                First name
              </label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="Enter your first name"
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                required
              />
            </div>
            <div>
              <label className="block text-gray-900 font-medium mb-2">
                Last name
              </label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Enter your last name"
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                required
              />
            </div>
          </div>

          {/* Email */}
          <div>
            <label className="block text-gray-900 font-medium mb-2">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
              required
            />
          </div>

          {/* Country and City */}
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="block text-gray-900 font-medium mb-2">
                Country of Residence<span className="text-red-600">*</span>
              </label>
              <div className="relative">
                <select
                  name="country"
                  value={formData.country}
                  onChange={handleCountryChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent appearance-none bg-white text-gray-900"
                  required
                >
                  <option value="">Select...</option>
                  {countries.map((country, index) => (
                    <option key={index} value={country.name}>
                      {country.name}
                    </option>
                  ))}
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <svg
                    className="w-5 h-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div>
              <label className="block text-gray-900 font-medium mb-2">
                City of Residence
              </label>
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="Enter your city"
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                required
              />
            </div>
          </div>

          {/* Gender and Phone Number */}
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="block text-gray-900 font-medium mb-3">
                Gender
              </label>
              <div className="flex gap-8">
                <label className="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="gender"
                    value="Female"
                    checked={formData.gender === "Female"}
                    onChange={handleChange}
                    className="w-4 h-4 text-red-600 border-gray-300 focus:ring-red-500"
                    required
                  />
                  <span className="ml-2 text-gray-900">Female</span>
                </label>
                <label className="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="gender"
                    value="Male"
                    checked={formData.gender === "Male"}
                    onChange={handleChange}
                    className="w-4 h-4 text-red-600 border-gray-300 focus:ring-red-500"
                  />
                  <span className="ml-2 text-gray-900">Male</span>
                </label>
              </div>
            </div>

            <div>
              <label className="block text-gray-900 font-medium mb-2">
                <span className="text-red-600">Phone Number</span>
              </label>
              <div className="flex gap-2">
                <input
                  type="text"
                  value={formData.phoneCode}
                  readOnly
                  placeholder="+234"
                  className="w-20 px-3 py-3 border border-gray-300 rounded-md bg-gray-50 text-gray-700 text-center font-medium"
                />
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  onBlur={validatePhoneNumber}
                  placeholder="Enter your phone number"
                  className={`flex-1 px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent ${
                    phoneError ? "border-red-500" : "border-gray-300"
                  }`}
                  required
                />
              </div>
              <p className="text-xs text-gray-500 mt-1">
                Please ensure you provide your WhatsApp number to access the
                membership class.
              </p>
              {phoneError && (
                <p className="text-xs text-red-600 mt-1 font-medium">
                  {phoneError}
                </p>
              )}
            </div>
          </div>

          {/* Mode of Participation and Are you a Minister */}
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="block text-gray-900 font-medium mb-2">
                Mode of Participation
              </label>
              <input
                type="text"
                name="modeOfParticipation"
                value={formData.modeOfParticipation}
                readOnly
                className="w-full px-4 py-3 border border-gray-300 rounded-md bg-gray-50 text-gray-500"
              />
            </div>
            <div>
              <label className="block text-gray-900 font-medium mb-2">
                Are you a Minister
              </label>
              <div className="relative">
                <select
                  name="isMinister"
                  value={formData.isMinister}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent appearance-none bg-white text-gray-900"
                  required
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <svg
                    className="w-5 h-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Expectations */}
          <div>
            <label className="block text-gray-900 font-medium mb-2">
              What are your expectations towards the Mentorship Academy
            </label>
            <textarea
              name="expectations"
              value={formData.expectations}
              onChange={handleChange}
              placeholder="Type your expectations here"
              rows="6"
              className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent resize-none"
              required
            ></textarea>
          </div>

          {/* Payment Currency and Payment Plan */}
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="block text-gray-900 font-medium mb-2">
                Payment Currency
              </label>
              <div className="relative">
                <select
                  name="paymentCurrency"
                  value={formData.paymentCurrency}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent appearance-none bg-white text-gray-900"
                  required
                >
                  <option value="NGN (₦)">NGN (₦)</option>
                  <option value="USD ($)">USD ($)</option>
                  <option value="GBP (£)">GBP (£)</option>
                  <option value="EUR (€)">EUR (€)</option>
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <svg
                    className="w-5 h-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div>
              <label className="block text-gray-900 font-medium mb-2">
                Payment Plan
              </label>
              <div className="relative">
                <select
                  name="paymentPlan"
                  value={formData.paymentPlan}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent appearance-none bg-white text-gray-900"
                  required
                >
                  <option value="">Select payment plan</option>
                  <option value="Full (₦225,000)">
                    Full Payment (₦225,000)
                  </option>
                  <option value="Installment">Installment (₦112,500)</option>
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <svg
                    className="w-5 h-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Payment Note */}
          <div className="text-center">
            <p className="text-gray-600 text-sm mb-6">
              Kindly note that the access to the ongoing mentorship is $150 or
              an equivalent of ₦225,000
            </p>
          </div>

          {/* Submit Button */}
          <div className="text-center">
            <button
              type="submit"
              className="bg-red-600 hover:bg-red-700 text-white px-16 py-3 rounded-md text-lg font-medium transition-colors duration-200 shadow-md hover:shadow-lg"
            >
              Submit
            </button>
          </div>
        </form>
      </div>

      {/* Email Already Registered Modal */}
      {showEmailExistsModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-2xl max-w-md w-full p-6 relative">
            <button
              onClick={() => setShowEmailExistsModal(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Email Already Registered
            </h3>
            <p className="text-gray-700 mb-4">
              An account with this email already exists. Please check your email
              for the payment link.
            </p>
            <p className="text-gray-600 mb-6">
              If you haven't received the payment link or would like it to be
              resent, click the button below.
            </p>

            <div className="flex gap-3">
              <button
                onClick={handleResendPaymentLink}
                className="flex-1 bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-md font-medium transition-colors"
              >
                Resend Payment Link
              </button>
              <button
                onClick={() => setShowEmailExistsModal(false)}
                className="flex-1 bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-md font-medium transition-colors"
              >
                Back to registration
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Registration Successful Modal */}
      {showSuccessModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-2xl max-w-md w-full p-8">
            <div className="text-center mb-4">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Registration Successful!
              </h3>
            </div>
            <p className="text-gray-700 text-center mb-6 leading-relaxed">
              Your registration has been completed successfully. An email with
              payment link has been sent to your inbox. You can also complete
              your payment now using the secure payment displaying now.
            </p>

            <button
              onClick={handleCloseSuccessModal}
              className="w-full bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-md font-medium transition-colors"
            >
              OK
            </button>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 px-4">
        <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">
          <div className="flex items-center gap-4 mb-4">
            <img
              src={footerLogo}
              alt="FLO Mentorship"
              className="h-16 w-auto drop-shadow-md"
            />
            <p className="text-gray-400 text-sm leading-relaxed max-w-md">
              Empowering individuals to unlock their full potential, molding
              them into dynamic changemakers poised to influence societies and
              industries across borders.
            </p>
          </div>

          <div>
            <h3 className="font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>
                <Link to="/" className="hover:text-red-500 transition">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/#about" className="hover:text-red-500 transition">
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/#curriculum"
                  className="hover:text-red-500 transition"
                >
                  Curriculum
                </Link>
              </li>
              <li>
                <Link
                  to="/#transformation"
                  className="hover:text-red-500 transition"
                >
                  Transformation
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold mb-4">Contact</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>Phone: +2348053695097</li>
              <li>Email: info@femilanreoke.org</li>
              <li>Address: Abuja, Nigeria</li>
            </ul>
            <div className="flex space-x-4 text-gray-400 mt-4">
              {/* Facebook */}
              <a
                href="https://web.facebook.com/profile.php?id=100072368183182"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-red-600 transition"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M22 12a10 10 0 1 0-11.5 9.9v-7h-2v-3h2v-2.3c0-2 1.2-3.1 3-3.1.9 0 1.8.1 1.8.1v2h-1c-1 0-1.3.6-1.3 1.2V12h2.3l-.4 3h-1.9v7A10 10 0 0 0 22 12z" />
                </svg>
              </a>
              {/* Instagram */}
              <a
                href="https://www.instagram.com/drfemilanreoke"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-red-600 transition"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M7 2C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7zm10 2c1.7 0 3 1.3 3 3v10c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3h10zm-5 3.5A4.5 4.5 0 1 0 16.5 12 4.5 4.5 0 0 0 12 7.5zm0 7.4A2.9 2.9 0 1 1 14.9 12 2.9 2.9 0 0 1 12 14.9zM17.8 6.2a1.1 1.1 0 1 1-1.1-1.1 1.1 1.1 0 0 1 1.1 1.1z" />
                </svg>
              </a>
              {/* YouTube */}
              <a
                href="https://www.youtube.com/@dr.Femilanre-oke"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-red-600 transition"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M23.5 6.2s-.2-1.6-.9-2.3c-.8-.9-1.8-.9-2.2-1C17.3 2.5 12 2.5 12 2.5h0s-5.3 0-8.4.4c-.4.1-1.4.1-2.2 1C.7 4.6.5 6.2.5 6.2S0 8.1 0 10v1.9c0 1.9.5 3.8.5 3.8s.2 1.6.9 2.3c.8.9 1.9.8 2.4.9 1.7.2 7.2.4 8.2.4s5.3 0 8.4-.4c.4-.1 1.4-.1 2.2-1 .7-.7.9-2.3.9-2.3s.5-1.9.5-3.8V10c0-1.9-.5-3.8-.5-3.8zM9.5 14.5v-5l5 2.5-5 2.5z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-8 pt-8 border-t border-gray-800 text-center text-gray-400 text-sm">
          <p>
            © 2026 Femi Lanre-Oke Mentorship Academy. All rights reserved.
            Powered by{" "}
            <a
              href="https://solidslategroups.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white transition-colors duration-300 underline decoration-gray-600 hover:decoration-white"
            >
              SOLIDSLATE GLOBAL SERVICES LTD
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
}
